import { createAction } from 'redux-starter-kit';
import api from 'api/categories';

export const fetchSuccess = createAction('categories/FETCH_SUCCESS');

export const loadCategories = type => dispatch => {
  /* const cachedKey = type + '_categories';
  const cachedCategories = localStorage.getItem(cachedKey);
  if (cachedCategories) {
    dispatch(fetchSuccess(JSON.parse(cachedCategories)));
  } */

  api.fetchCategories(type).then(categories => {
    // localStorage.setItem(cachedKey, JSON.stringify(categories));
    dispatch(fetchSuccess(categories));
  });
};

export default {
  loadCategories,
  fetchSuccess
};
